/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_No_Products_SelectedInputs */

const en_inventory_no_products_selected = /** @type {(inputs: Inventory_No_Products_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No products selected`)
};

const es_inventory_no_products_selected = /** @type {(inputs: Inventory_No_Products_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay productos seleccionados`)
};

/**
* | output |
* | --- |
* | "No products selected" |
*
* @param {Inventory_No_Products_SelectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_no_products_selected = /** @type {((inputs?: Inventory_No_Products_SelectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_No_Products_SelectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_no_products_selected(inputs)
	return es_inventory_no_products_selected(inputs)
});